import React from 'react'
import { Link } from 'react-router-dom'
import arrowBack from '@/assets/images/svg/arrow-back-thin.svg'

export const BackButton = ({ className }: { className?: string }) => {
  return (
    <div className={`w-full ${className || ''}`}>
      <Link
        to="/"
        className="flex items-center justify-center w-10 h-10 rounded-full border-[1px] border-backButtonBorder hover:opacity-70 transition-all duration-300"
      >
        <img width={24} height={24} src={arrowBack} alt="arrow-back" />
      </Link>
    </div>
  )
}
